import { Notifier } from "@airbrake/browser";
import { Nullable } from "@bringg/types";

import { airbrake } from "../airbrake";
export const useAirbrake = (): Nullable<Notifier> => airbrake;
